










































import { Vue, Component, Prop } from 'vue-property-decorator';
import jwtDecode from 'jwt-decode';

import SignUpService from '@/api/SingupService';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

import { BusinessOnboardingLink } from '@/models/business-onboarding';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    TwismLogoIcon,
    CloseModalIcon
  }
})
export default class BaseLayout extends Vue {
  @Prop({ default: false }) hideIlustraOnMobile?: boolean;
  @Prop({ default: 'light' }) logoTheme?: 'dark' | 'light';
  @Prop({ default: true }) showNavLinks?: boolean;
  @Prop({ default: true }) scrollRightCol?: boolean;
  @Prop({ default: false }) removeMarginNav?: boolean;

  signUpService = new SignUpService();
  managerCredentials: Record<string, any> | null = null;

  get links() {
    return this.$store.getters[
      'businessOnboarding/getNavLinks'
    ] as BusinessOnboardingLink[];
  }

  get transformedLinks() {
    const activeIndex = this.links.findIndex(link =>
      link.routes.includes(this.$route.name || '')
    );

    return this.links.map((link, linkIndex) => {
      const routesAmount = link.routes.length;
      const internalActiveIndex = link.routes.findIndex(
        rouName => rouName == this.$route.name
      );
      const fraction = 100 / routesAmount;

      const isPrevLink = linkIndex < activeIndex;

      return {
        ...link,
        activePercentage: isPrevLink
          ? 100
          : (internalActiveIndex * 100) / routesAmount + fraction
      };
    });
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isLogged() {
    const token = this.signUpService.getCredentials();

    return !!token || this.$store.getters['manager/isImpersonated'];
  }

  get showCloseBtn() {
    return (
      !!this.business && !!this.isLogged && !isExternalOauthSessionOnline()
    );
  }

  mounted() {
    this.getManagerCredentials();
  }

  getManagerCredentials() {
    const managerCredentials = this.signUpService.getCredentials();

    if (managerCredentials) {
      this.managerCredentials = jwtDecode(managerCredentials).extraInfo;
    }
  }
}
